module.exports = __webpack_public_path__ + "static/img/news79_40.1fbd7fe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/technology/news79/news79_40.webp
// module id = jQ2H
// module chunks = 0